import styled from "styled-components"
import { Text } from "@pancakeswap/uikit"
import FlexLayout from "components/Layout/Flex"

export const CardLayout = styled(FlexLayout)`
  justify-content: space-around;
  align-items: center; 
  background: #0C0E1C; 
  border: 1px solid ${({ theme }) => theme.colors.darkborder};
  box-shadow: 0 0 24px #000, 1px 1px 2px -1px #fff, -1px -1px 2px -1px #fff; 
  width: 98%; 
  padding: 4px; 
  padding-bottom: 2rem; 
  border-radius: 24px; 
  @media (min-width: 1000px) {
    width: 95%; 
    padding: 4px; 
    padding-top: 1rem; 
    border-radius: 32px; 
    margin-bottom: 2rem; 
  }
  @media (min-width: 1500px) {
    width: 90%; 
    padding: 1rem; 

  }
`

export const PoolsHeader = styled(Text)`
  font-weight: 500 ;
  color: #fff;
  margin-bottom: 0px;

  text-transform: uppercase;
  font-size: 40px;
  @media (min-width: 1000px) {
    font-size: 68px;

  }
`